/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ShowDesktopNotification: BridgeCommands.Command<
    Types.Common.Desktopnotification.ShowDesktopNotificationParameters,
    Types.Common.Desktopnotification.ShowDesktopNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DesktopNotification',
    method: 'ShowDesktopNotification',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ClearDesktopNotification: BridgeCommands.Command<
    Types.Common.Desktopnotification.ClearDesktopNotificationParameters,
    Types.Common.Desktopnotification.ClearDesktopNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DesktopNotification',
    method: 'ClearDesktopNotification',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const IsValidDesktopNotification: BridgeCommands.Command<
    Types.Common.Desktopnotification.IsValidDesktopNotificationParameters,
    Types.Common.Desktopnotification.IsValidDesktopNotificationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DesktopNotification',
    method: 'IsValidDesktopNotification',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DesktopNotificationsAllowed: BridgeCommands.Command<
    {},
    Types.Common.Desktopnotification.DesktopNotificationsAllowedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DesktopNotification',
    method: 'DesktopNotificationsAllowed',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DesktopNotificationActivated: BridgeCommands.Command<
    {},
    Types.Common.Desktopnotification.DesktopNotificationActivatedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DesktopNotification',
    method: 'DesktopNotificationActivated',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DesktopNotificationDismissed: BridgeCommands.Command<
    {},
    Types.Common.Desktopnotification.DesktopNotificationDismissedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DesktopNotification',
    method: 'DesktopNotificationDismissed',
    persistent: true
};

export const Desktopnotification = {
ShowDesktopNotification,
ClearDesktopNotification,
IsValidDesktopNotification,
DesktopNotificationsAllowed,
DesktopNotificationActivated,
DesktopNotificationDismissed
};
